
import Vue from 'vue'
import ModalSocialShare from '@/components/ModalSocialShare.vue'

export default Vue.extend({
  components: {
    ModalSocialShare
  },
  props:{
    eventLabel: {
      type: String,
      required: true
    }
  },
  data(): {
     isOpenModalSocialShare: boolean
  } {
    return {
      isOpenModalSocialShare: false
    }
  },
  computed: {
    editorPage(): boolean {
      return this.$route.path == '/editor'
    }
  },
  created() {
    this.$root.$on('showSocialShareModal', () =>{
      this.openShareModalHandler()
    })
  },
  methods: {
    openShareModalHandler(){
      this.isOpenModalSocialShare = true
    }
  }
})
